const STRIPE_JS_URL = 'https://js.stripe.com/v3/';

let loadPromise: Promise<void> | null = null;

export function loadStripeJs(): Promise<void> {
  if (typeof window === 'undefined') return Promise.resolve(); // SSR safety
  if (windowHasStripe()) return Promise.resolve();
  if (loadPromise) return loadPromise;

  loadPromise = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = STRIPE_JS_URL;
    script.async = true;

    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load Stripe.js: ${STRIPE_JS_URL}`));

    document.head.appendChild(script);
  });

  return loadPromise;
}

export function windowHasStripe(): boolean {
  return typeof window !== 'undefined' && typeof (window as any).Stripe !== 'undefined';
}

export function getStripe(): any {
  return (window as any).Stripe;
}
